import React, {Component} from 'react';
import {Field, reduxForm} from 'redux-form';
import CustomTextField from '../Input/CustomTextField';
import {compose} from 'redux';
import CircularProgress from '@material-ui/core/CircularProgress';
import Button from '@material-ui/core/Button';
import {withStyles} from '@material-ui/core/styles';
import {withTranslation} from 'react-i18next';
import IntlMessage from '../../util/IntlMessage';
import InputAdornment from '@material-ui/core/InputAdornment';
import EmailIcon from '@material-ui/icons/Email';

const styles = {
  form: {
    padding: '0 1em 1em 1em',
  },
  forgotPasswordButton: {
    textTransform: 'none',
    marginTop: '16px'
  }
};

class ForgotPasswordForm extends Component {
    render() {
        const {t: translate, classes, handleSubmit, isLoading, onSubmit} = this.props;

        return (
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className={classes.form}>
                <p className="mb-0" style={{textAlign: 'left'}}>{translate('forgot_password.forgot_password_suggestion')}</p>
                <Field
                    type="email"
                    name="email"
                    id="user-mail"
                    autoFocus
                    label={<IntlMessage id="common.email"/>}
                    component={CustomTextField}
                    InputProps={{
                      endAdornment: (
                          <InputAdornment position="end">
                            <EmailIcon/>
                          </InputAdornment>
                      )
                    }}
                    variant="outlined"
                />
                <Button
                    type='submit'
                    variant="contained"
                    size="medium"
                    fullWidth
                    className={`btn-primary tour-step-4 text-white ${classes.forgotPasswordButton}`}
                    color="primary"
                >
                  {isLoading && (
                      <CircularProgress size={25} thickness={2}/>
                  )}
                  {translate('forgot_password.reset_password')}
                </Button>
              </div>
            </form>
        );
    }
}

const enhanceForgotPassword = compose(
    withTranslation(),
    reduxForm({
        form: 'forgotPassword',
        validate: (values) => {
            const errors = {};

            if (!!values.email && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
              errors.email = 'Email is invalid';
            }

            return errors;
        }
    }),
    withStyles(styles)
);

export default enhanceForgotPassword(ForgotPasswordForm);